// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'star-solid';

export const Component = () => (
  <path d='m23.812 10.235-5.563 4.95 1.496 7.754v.094c0 .327-.187.467-.514.467-.094 0-.14 0-.187-.046l-6.591-3.41-6.544 3.41h-.094c-.047.046-.094.046-.14.046-.328 0-.468-.14-.468-.467v-.094l1.543-7.753-5.61-4.951A.528.528 0 0 1 1 9.86c0-.233.14-.42.42-.467l7.34-1.168 3.32-6.446c.046-.186.186-.28.42-.28.187 0 .327.094.42.233l3.32 6.493 7.34 1.168c.28.046.42.233.42.467 0 .14-.047.233-.187.373h-.001Z' />
);

export const viewBox = '0 0 25 25';
